<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">
  <!-- Trip Filters -->
<div class="flex flex-wrap xl:flex-nowrap flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
  <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
    <div class="relative">
      <input [(ngModel)]="search" type="text" placeholder="Search.." class="pl-8" />
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
    </div>
    <div>
      <div>
        <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
          [owlDateTimeTrigger]="date" [selectMode]="'range'" [readonly]="true" />
        <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange($event)" #date></owl-date-time>
      </div>
    </div>
  </div>
  <!--trips submenu-->
  <div class="flex items-center gap-2">
    <div
    class="hidden md:inline-flex border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 gap-1 overflow-hidden rounded-md bg-white dark:bg-zinc-900 p-1">
    <a *ngFor="let menu of subMenus" href="javascript:void(0)" (click)="onSelectMenu(menu.value)"
      [ngClass]="{'bg-zinc-950/80 dark:bg-zinc-700 text-white': selectedStatus === menu.value, 'bg-white dark:bg-zinc-900 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-zinc-800': selectedStatus !== menu.value}"
      class="relative inline-flex whitespace-nowrap items-center px-1 py-1.5 text-xs font-medium rounded">
      {{menu.name}}
      <div *ngIf="selectedStatus === menu.value && trips.length > 0"
        class="ml-1 grid place-content-center text-xs px-1 bg-white dark:bg-zinc-300 text-zinc-600 dark:text-zinc-800 rounded">
         <span>{{ getPageCount() }}</span>
      </div>
    </a>
  </div>
  <div class="relative inline-block text-left" (outsideClick)="closeFilterDropDown($event)" outside-click>
    <div>
      <button [appToolTip]="'Filters'" type="button" (click)="toggleDropdown($event)" class="btn btn-secondary" id="menu-button"
        aria-expanded="true" aria-haspopup="true">
  
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
        </svg>
        <span 
             *ngIf="(selectedSpaceType && selectedSpaceType.length > 0)"
              class="flex absolute h-3 w-3 -top-1 -right-1">
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 bg-red-500"></span>
              <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
            </span>
      </button>
    </div>
    <div *ngIf="isDropdownOpen"
      class="absolute right-0 z-50 mt-2 w-72 origin-top-right rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
      role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
      <div class="p-3 grid grid-cols-2 gap-2" role="none">
        <!-- Active: "bg-gray-100 text-gray-900 outline-none", Not Active: "text-gray-700" -->
        <!-- assign Button -->
        <div class="sm:col-span-2" role="menuitem" tabindex="-1" id="menu-item-0">
          <label for="Space type" class="text-xs font-bold">Space Type</label>
          <select class="" [(ngModel)]="selectedSpaceType" (change)="onSpaceTypeChange()">
            <option value="">Select Space Type</option>
            <option *ngFor="let spaceType of spacetypes" value="{{spaceType.id}}">{{ spaceType.title | uppercase }}
            </option>
          </select>
        </div>
        <hr *ngIf="selectedTrips && selectedTrips.length" class="sm:col-span-2 dark:border-white/10">
        <div class="sm:col-span-2 mt-2" role="menuitem" tabindex="-1" id="menu-item-1">
          <div class="p-1 grid grid-cols-1 gap-1">
            <button *ngIf="trips && trips.length" (click)="getDateRangeWiseTrips()" class="btn btn-secondary text-xs w-full">
              Trips Report
            </button>
            <div *ngIf="selectedTrips && selectedTrips.length" class="p-1 grid grid-cols-1 gap-1">
              <button *ngIf="['completed'].includes(selectedStatus)" (click)="bulkVendorAdjust()"
              class="btn btn-secondary text-xs w-full">
              Adjust
            </button>
            </div>
            <!-- <button *ngIf="['completed'].includes(selectedStatus)" (click)="bulkFundingSourceAdjust()"
              class="btn btn-secondary text-xs w-full">
              Adjust FS
            </button> -->
          </div>
        </div>
  
      </div>
    </div>
  </div>
  </div>
</div>

<!-- Tris List -->
<div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
  <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
    <div class="flow-root h-full overflow-y-auto"> 
  <div class="-my-2">
    <div class="inline-block min-w-full py-2 align-middle">
      <table class="min-w-full table-auto">
        <thead class="bg-zinc-950/5 dark:bg-white/5">
          <tr>
            <th
              class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              #</th>
                      <th
                        *ngIf="filterdataList.length && (selectedStatus !== 'onway' && selectedStatus !== 'arrived' && selectedStatus !== 'in_progress') && permissionService.hasPermission([userPermission.MANAGE_TRIP])"
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        <input type="checkbox" [checked]="selectedTrips.length && selectedTrips.length === filterdataList.length"
                          (change)="onSelectAllTrips($event)" />
                      </th>
            <th
              class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
              Action</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Stamps</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Service Area</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Reference ID
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Association
                  </th>
                  <!-- <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Funding Source
                  </th> -->
                  <!-- <th *ngIf="selectedStatus !== 'scheduled' "
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Company</th> -->
                  
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Member</th>
                    <th *ngIf="selectedStatus !== 'scheduled'"
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Driver</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Contact No.</th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Pickup Time
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Dropoff Time
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Pickup Address</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Dropoff Address</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Miles</th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Space Type</th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    LOS</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Appointment Type</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Created At </th>
                    <th *ngIf="selectedStatus === 'reroute' || selectedStatus === 'cancelled'"
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      {{ selectedStatus === 'reroute' ? 'Change Reason' : 'Cancel Reason' }}
                    </th>
                    <th *ngIf="['cancelled', 'completed'].includes(selectedStatus)"
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Billing Status </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    General Notes</th>
                </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let trip of trips | filter: search | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i=index"
            class="hover:bg-gray-950/5 dark:hover:bg-white/10">
              <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    {{i+1}}
                  </td>
                  <td
                    *ngIf="trips.length && (selectedStatus !== 'onway' && selectedStatus !== 'arrived' && selectedStatus !== 'in_progress') "
                    class="relative px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <!-- Selected row marker, only show when row is selected. -->
                    <div class="absolute inset-y-0 left-0 w-0.5 bg-main-primary"
                      [ngClass]="{'hidden': !trip.isSelected}">
                    </div>
                    <input (click)="onSelectTrip(trip)" type="checkbox" [(ngModel)]="trip.isSelected" 
                    *ngIf="permissionService.hasPermission([userPermission.MANAGE_TRIP])"type="checkbox"  />
                  </td>
                  <!-- actions -->
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <div class="flex">
                      <button [appToolTip]="'Detail'" (click)="opendetailModal(trip)"
                        class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="w-5 h-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                        </svg>
                      </button>
                      <!-- <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                      <button (click)="openTripTrails(trip)"
                        class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                          class="h-5 w-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
                        </svg>
                      </button> -->

                      <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                      <button [appToolTip]="'Notes'" (click)="openNotesModal(trip)"
                        class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
                          class="h-5 w-5">
                          <path fill="currentColor"
                            d="M7.154 13.539q.31 0 .54-.23q.229-.23.229-.54t-.23-.54t-.54-.229t-.538.23t-.23.54q0 .309.23.539t.539.23m0-2.77q.31 0 .54-.23q.229-.23.229-.539t-.23-.54t-.54-.23t-.538.23t-.23.54t.23.54t.539.23m0-2.77q.31 0 .54-.23t.229-.54t-.23-.539t-.54-.23t-.538.23t-.23.54t.23.54t.539.229m3.077 5.27H14.5v-1h-4.27zm0-2.77H17.5v-1h-7.27zm0-2.77H17.5v-1h-7.27zM3 20.078V4.616q0-.691.463-1.153T4.615 3h14.77q.69 0 1.152.463T21 4.616v10.769q0 .69-.463 1.153T19.385 17H6.077zM5.65 16h13.735q.23 0 .423-.192t.192-.423V4.615q0-.23-.192-.423T19.385 4H4.615q-.23 0-.423.192T4 4.615v13.03zM4 16V4z" />
                        </svg>
                      </button>
                      <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                      <div class="inline-flex relative"  *ngIf="permissionService.hasPermission([userPermission.MANAGE_TRIP])">
                        <!-- *ngIf="!assign.isJClone" -->
                        <a [appToolTip]="'More Actions'" *ngIf="!trip.isSelected" href="javascript:void(0)" (click)="showActionButtons(i)"
                          class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                          </svg>
                        </a>
                        <div (outsideClick)="closeActionMenu($event)" outside-click
                          *ngIf="selectedDropdownIndex === i && toggleActionButtons"
                          class="absolute left-4 z-20 my-4 w-64 origin-top-left rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                          role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                          <!-- (addAdditionalNote)="addAdditionalNote(assign, i)" -->
                          <app-trip-action-dropdown class="divide-y divide-zinc-950/10 dark:divide-white/10"
                            [trip]="trip" [source]="'trips'" (assign)="assignSingleTrip($event)" (edit)="editTrip($event)"
                            (detail)="opendetailModal($event)" (raiseTicket)="raiseTicket($event)" (cancel)="cancelSignleTrip($event)" (reroute)="reRouteTrip($event)"
                            (notes)="openNotesModal($event)" (sendtoMarketplace)="sendtoMarketPlace($event,i)"
                            (GetbackFromMarketplace)="backtoSchedule($event,i)"
                            (autoDistribute)="openAutoDistributionModal($event)"
                            (adjustTrip)="openAdjustTrip($event)"
                            (tripTrails)="openTripTrails($event)"
                            (signature)="openSignatureModal($event)"
                            ></app-trip-action-dropdown>
                        </div>
                      </div>
                    </div>
                  </td>
            <!-- stamps -->
             <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <div class="flex items-center gap-1">
                      <!-- isReady -->
                      <span *ngIf="trip?.flags?.isReady" class="badge-success my-1"> Ready </span>
                      <!-- isVip -->
                      <span *ngIf="trip?.flags?.isVip"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#D0AA00]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#D0AA00] sm:text-xs/5 forced-colors:outline">
                        VIP </span>
                      <!-- notAnswer -->
                      <span *ngIf="trip?.flags?.isUnanswered"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FF8080]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FF8080] sm:text-xs/5 forced-colors:outline">
                        No Answer </span>
                      <!-- isInvalidNumber -->
                      <span *ngIf="trip?.flags?.isInvalidNumber"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#B3BFFF]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#B3BFFF] sm:text-xs/5 forced-colors:outline">
                        Invalid Number </span>
                      <!-- isConfirmed -->
                      <span *ngIf="trip?.flags?.isConfirmed"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FEA405]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FEA405] sm:text-xs/5 forced-colors:outline">
                        Confirmed </span>
                      <!-- isVoiceMail -->
                      <span *ngIf="trip?.flags?.isVoiceMail"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#4DA8DA]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#4DA8DA] sm:text-xs/5 forced-colors:outline">
                        Voice Mail </span>
                      <!-- isMultiLoad -->
                      <span *ngIf="trip?.flags?.isMultiLoad"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#5682B1]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#5682B1] sm:text-xs/5 forced-colors:outline">
                        Multi Load </span>
                      <!-- isDeadMiles -->
                      <span *ngIf="trip?.flags?.isDeadMiles"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#CD2C58]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#CD2C58] sm:text-xs/5 forced-colors:outline">
                        Dead Miles </span>
                      <!-- isMethadone -->
                      <span *ngIf="trip?.flags?.isMethadone"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#27B107]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#27B107] sm:text-xs/5 forced-colors:outline">
                        Methadone </span>
                      <!-- isClone -->
                      <span *ngIf="trip?.flags?.isClone"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#27B107]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#27B107] sm:text-xs/5 forced-colors:outline">
                        Clone </span>
                      <!-- isEstimation -->
                      <span *ngIf="trip?.flags?.isEstimation"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#27B107]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#27B107] sm:text-xs/5 forced-colors:outline">
                        Estimation </span>
                        <ng-container *ngIf="trip?.status == 'cancelled'">
                        <span *ngIf="trip.flags.isBillable"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FEA405]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FEA405] sm:text-xs/5 forced-colors:outline">
                        Billable </span>
                           <!-- noshow -->
                      <span *ngIf="trip.flags.isNoShow"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FF8080]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FF8080] sm:text-xs/5 forced-colors:outline">
                        No Show </span>
                      </ng-container>
                        <!-- isWillCallActivated -->
                      <span *ngIf="trip?.flags?.isWillCallActivated && ['reroute', 'offered'].includes(trip?.status)"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#27B107]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#27B107] sm:text-xs/5 forced-colors:outline">
                        WillCall Activated 
                      </span>
                        <!-- Adjusted -->
                      <span *ngIf="trip?.billing && trip?.billing?.billingStatus && ['completed', 'cancelled'].includes(trip?.status)"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-[#27B107]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#27B107] sm:text-xs/5 forced-colors:outline">
                        Adjusted </span>
                    </div>

              </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              <span *ngIf="preServiceAreas && preServiceAreas[trip.serviceArea]">
                {{preServiceAreas[trip.serviceArea].title ? (preServiceAreas[trip.serviceArea].title | titlecase) :
                'N/A'}}
              </span>
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              <span>
                {{trip.reference || 'N/A'}}-{{trip.suffix || 'N/A'}}
              </span>
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              <span>
                {{trip.association || 'N/A'}}
              </span>
            </td>
            <!-- --Funding Source-- -->
            <!-- <td
                              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                              <span *ngIf="preFundingSource && trip.fundingSource">
                                {{preFundingSource[trip.fundingSource]?.title}}
                              </span>
                            </td> -->
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              <!-- <span *ngIf="preMembers && preMembers[trip.member]">
                              {{preMembers[trip.member].firstName}}
                            </span> -->
              {{trip.member?.displayName | titlecase}}
            </td>
            <!-- <td
                          class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                          <span *ngIf="preCompanies && preCompanies[trip.company]">
                            {{(preCompanies[trip.company].name | titlecase) || 'N/A'}}
                          </span>
                        </td> -->
            <td *ngIf="selectedStatus !== 'scheduled'"
              class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              <span *ngIf="trip.driver else elseBlock">
                {{((trip.driver.displayName) | titlecase ) || 'N/A'}}
              </span>
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap" phoneNumberFormat [phoneNumber]="trip?.member?.contactNumber">
              {{ trip?.member?.contactNumber || 'N/A'}}
            </td>

            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              {{(trip?.pickup.time | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              {{(trip?.destination.time | date: 'MM/DD/YYYY HHmm')|| 'N/A'}}</td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              {{trip?.pickup?.address?.name || 'N/A'}}</td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              {{trip?.destination?.address?.name || 'N/A'}}</td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              {{ trip.miles ? trip.miles.toFixed(2) + ' mi' : 'N/A' }}
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              <span *ngIf="preSpacetypes && preSpacetypes[trip.spaceType]">
                {{(preSpacetypes[trip.spaceType].title | uppercase) || 'N/A'}}
              </span>
            </td>
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
              <span *ngIf="preLevelOfService && preLevelOfService[trip.levelOfService]">
                {{(preLevelOfService[trip.levelOfService].title | uppercase) || 'N/A'}}
              </span>
            </td>
            <!-- appointmentType -->
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              <span *ngIf="preAppointmentType && preAppointmentType[trip.appointmentType]">
                {{(preAppointmentType[trip.appointmentType].title | titlecase) || 'N/A'}}
              </span>
            </td>
            <!-- createdAt -->
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
              {{(trip.createdAt | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</td>
               <!-- change reason -->
                   <td *ngIf="selectedStatus === 'reroute' || selectedStatus === 'cancelled' "
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 ">
                   <div class="w-72 line-clamp-2">
                     {{ (trip.changeReasonNotes | titlecase) || 'N/A'}}
                    </div>
                  </td> 
                  <!-- billing status -->
                  <td *ngIf="['cancelled', 'completed'].includes(selectedStatus)"
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 ">
                    <div [ngClass]="trip?.billing?.billingStatus === 'rejected' ? 'badge-danger' : 'badge-primary'">
                      {{(trip?.billing?.billingStatus
                      | titlecase) || 'N/A'}}
                    </div>
                  </td>
            <!-- generalNotes -->
            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
              <div class="w-72 line-clamp-2">
                {{ trip.generalNotes || 'N/A'}}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
       <ng-template #elseBlock>N/A</ng-template>
    </div>
  </div>
</div>
</div>
  <div class="mt-2 flex justify-end">
    <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
  </div>
</div>
</section>

<app-trip-detail-modal *ngIf="tripId" [tripId]="tripId" (closeModal)="tripId = null"></app-trip-detail-modal>
<app-notes-modal *ngIf="memberNotesObj" [notes]="memberNotesObj" (closeModal)="memberNotesObj = null"></app-notes-modal>
<app-trip-trails-modal *ngIf="trailsTripId" [tripId]="trailsTripId" (closeModal)="trailsTripId = null"></app-trip-trails-modal>
<app-multi-cancel-modal *ngIf="isMultiCancelModal" [source]="source" [trips]="singleTrip ? singleTrip : selectedTrips"
  [preServiceAreas]="preServiceAreas" (cancelTripData)="onCancelTrip($event)"
  (closeModal)="closeMultiCancelModal()"></app-multi-cancel-modal>
  <app-trip-signature-modal *ngIf="signatureModalObj" [trip]="signatureModalObj" [source]="'trips'"
    (closeModal)="onCloseSignatureModal($event)"></app-trip-signature-modal>